export * from './contact';
export * from './student';
export * from './company';
export * from './group';
export * from './location';
export * from './universe';
export * from './partner';



// WEBPACK FOOTER //
// ./src/app/_screens/directory/index.ts